export const seekShow1 = () => {
    this.codeRigBox();
    if (this.isSeekBox === 1) {
        this.isSeekBox = false;
        let dom = document.getElementById("translation");
        let seekActive = dom.getElementsByClassName("seekActive");
        let len = seekActive.length;
        if (len > 0) {
            for (let i = len - 1; i > -1; i--) {
                if (i >= 0) {
                    seekActive[i].style.background = "";
                    seekActive[i].classList.remove("seekActive");
                }
            }
        }
        this.seekTxt = "";
    } else {
        this.isSeekBox = 1;
        this.seekChange();
    }
};
export const debounce = (fn, timerDelay, immediate) => {
    let timer;
    return function () {
        let that = this;
        let args = arguments;

        if (timer) clearTimeout(timer);
        if (immediate) {
            var callNow = !timer;
            timer = setTimeout(() => {
                timer = null;
            }, timerDelay)
            if (callNow) fn.apply(that, args)
        } else {
            timer = setTimeout(function () {
                fn.apply(that, args)
            }, timerDelay);
        }
    }
}
